import React from "react";
import ListItems from "../List/ListItems";
import Image from "../../components/image/Image";
import { Container } from "../../components/container/Container";

const BlogTwoSection = ({ data }) => {
  return (
    <Container className="flex flex-col md:flex-row justify-between items-center px-4 py-6">
      <ListItems
        items={data}
        className="text-black py-2 text-left w-full md:w-auto"
      />
      <Image
        src="/whyOurBlog.png"
        alt="Blog Image"
        className="p-0 w-full md:w-1/2 lg:w-1/3"
      />
    </Container>
  );
};

export default BlogTwoSection;
